import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from "../../../Components/Loader";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { DataGrid } from "@mui/x-data-grid";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const TherapyMappingMaster = () => {
    const [formState, setFormState] = useState({
        therapist: null,
        treatments: [],
    });
    const [therapists, setTherapists] = useState([]);
    const [treatments, setTreatments] = useState([]);
    const [mappingList, setMappingList] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);

    // toast + loader + delete states
    const [message, setMessage] = useState({
        isErrorMsgText: "",
        successMsgText: "",
        isErrorMsg: false,
        successMsg: false,
    });
    const [isloader, setisloader] = useState(false);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    let commonDisable = CheckAccessFunc("ayurveda", "Settings", "Therapy Mapping", "Therapy Mapping Master", "SubTab")?.editAccess;

    useEffect(() => {
        getTherapists();
        getTreatments();
        getMappings();
    }, []);

    const getTherapists = () => {
        try {
            setisloader(true);
            RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPIST_MASTER)
                .then((response) => {
                    if (response.data.status === "success") {
                        setTherapists(response?.data?.data || []);
                    }
                    setisloader(false);
                })
                .catch((e) => {
                    setisloader(false);
                    errorMessage(e?.message);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e?.message);
        }
    };

    const getTreatments = () => {
        try {
            RestAPIService.getAll(Serviceurls.AYURVEDA_TREATMENT_MASTER)
                .then((response) => {
                    if (response.data.status === "success") {
                        setTreatments(response?.data?.data || []);
                    }
                })
                .catch((e) => {
                    errorMessage(e?.message);
                });
        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const getMappings = () => {
        try {
            setisloader(true);
            RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPY_MAPPING)
                .then((response) => {
                    if (response.data.status === "success") {
                        setMappingList(response?.data?.data || []);
                    }
                    setisloader(false);
                })
                .catch((e) => {
                    setisloader(false);
                    errorMessage(e?.message);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e?.message);
        }
    };

    const AddMapping = () => {
        try {
            if (!formState.therapist) {
                return errorMessage("Please select Therapist");
            }
            if (!formState.treatments.length) {
                return errorMessage("Please select at least one Treatment");
            }

            let data = {
                employee: formState?.therapist?.id,
                treatment: formState?.treatments?.map((t) => t.id),
                is_active: isActive,
            };

            setisloader(true);
            let apiCall;
            if (EditID) {
                apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_THERAPY_MAPPING);
            } else {
                apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_THERAPY_MAPPING);
            }
            apiCall
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        clearForm();
                        getMappings();
                    }
                    setisloader(false);
                })
                .catch((e) => {
                    setisloader(false);
                    errorMessage(e?.message);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e?.message);
        }
    };

    const clearForm = () => {
        setFormState({ therapist: null, treatments: [] });
        setIsActive(true);
        setEditID(null);
    };

    const deleteMapping = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || []);
            RestAPIService.delete(Serviceurls.AYURVEDA_THERAPY_MAPPING + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        getMappings();
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false);
                    }
                })
                .catch((e) => {
                    errorMessage(e?.message);
                });
        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        });
    };

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        });
    };

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: false,
            successMsgText: "",
        });
    };

    const tableView = () => {
        const grpDelete = () => setisDelete(true);
        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText
                    isDelete={delIDs?.length > 0}
                    removeData={grpDelete}
                />
            </Box>
        );

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id);
            let selectedRows = mappingList?.filter((row) => selectedIDs.has(row.sno));
            let FinalData = selectedRows.map((item) => item.id);
            setdelIDs(FinalData);
        };

        mappingList?.forEach((element, index) => (element.sno = index + 1));

        const columns = [
            {
                field: "sno",
                headerName: "S.No",
                flex: 0.05,
                sortable: false,
                renderCell: (params) => (
                    <Typography fontSize={"0.9vw"}>
                        {params.row.sno}
                    </Typography>
                ),
            },
            {
                field: "therapist",
                headerName: "Therapist",
                flex: 0.2,
                valueGetter: (params) => therapists?.find((t) => t.id === params.row.employee)?.name || "",  // For search
                renderCell: (params) => (
                    <Box>
                        {params.value || "-"}
                    </Box>
                ),
            },
            {
                field: "treatments",
                headerName: "Treatments",
                flex: 0.4,
                valueGetter: (params) => (params.row.treatment || [])
                    .map((tid) => treatments.find((t) => t.id === tid)?.treatment_name)
                    .filter(Boolean)
                    .join(" "),  // For search
                renderCell: (params) => {
                    let names = params.value.split(" ").filter(Boolean);  // Reuse the valueGetter result
                    return names.length > 3 ? (
                        <Tooltip title={names.join(", ")}>
                            <Typography fontSize={"0.9vw"}>
                                {names.slice(0, 2).join(", ")}...
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={"0.9vw"}>{names.join(", ")}</Typography>
                    );
                },
            },
            {
                field: "is_active",
                headerName: "Status",
                flex: 0.1,
                renderCell: (params) => (
                    <Box>{params.row.is_active ? "Active" : "In Active"}</Box>
                ),
            },
            ...(commonDisable
                ? [
                    {
                        field: "action",
                        headerName: "Action",
                        flex: 0.15,
                        headerAlign: "center",
                        align: "center",
                        renderCell: (params) => (
                            <Stack direction="row" spacing={1}>
                                <CommonEditButton
                                    size="1.5vw"
                                    onClick={() => {
                                        setFormState({
                                            therapist: therapists?.find(
                                                (t) => t.id === params.row.employee
                                            ),
                                            treatments: treatments.filter((t) =>
                                                params.row.treatment.includes(t.id)
                                            ),
                                        });
                                        setIsActive(params.row.is_active || false);
                                        setEditID(params.row.id);
                                    }}
                                />
                            </Stack>
                        ),
                    },
                ]
                : []),
        ];

        return (
            <Box>
                <Box sx={{ height: "64vh" }}>
                    <DataGrid
                        checkboxSelection={commonDisable ? true : false}
                        selectionModel={CheckBoxList}
                        onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                        rows={mappingList || []}
                        columns={columns}
                        getRowId={(row) => row["sno"]}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarExportPrint: "",
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    {"No Records To Be Shown"}
                                </Box>
                            ),
                        }}
                        pageSizeOptions={[10, 20, 30]}
                        pagination
                        paginationMode="client"
                        paginationModel={{
                            page: page,
                            pageSize: pageSize
                        }}
                        onPaginationModelChange={(model) => {
                            setpage(model.page)
                            setpageSize(model.pageSize)
                        }}
                        headerHeight={40}
                        density="compact"
                        disableRowSelectionOnClick
                        loading={isloader}
                        getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                        sx={{
                            "& .gray-row .MuiDataGrid-cell": {
                                backgroundColor: "#e8e7e7 !important",
                                color: "black !important",
                            },
                            "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                                backgroundColor: "white !important",
                                color: "black !important",
                            },
                            "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                                backgroundColor: "white !important",
                            }
                        }}
                    />
                </Box>
            </Box>
        );
    };

    return (
        <Box sx={{ height: "79.5vh", width: "94vw", backgroundColor: Colors.Background, padding: ".5vw" }}>
            {/* Form Section */}
            <Box sx={{ height: "15vh", width: "93vw", backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: "flex", flexDirection: "row", gap: "1vw" }}>
                    <Autocomplete
                        options={therapists}
                        value={formState.therapist}
                        getOptionLabel={(o) => o?.name || ""}
                        onChange={(e, val) => setFormState((prev) => ({ ...prev, therapist: val }))}
                        renderInput={(params) => <TextField {...params} label="Therapist *" size="small" />}
                        sx={{ width: "15vw" }}
                    />
                    <Autocomplete
                        multiple
                        size="small"
                        limitTags={1}
                        options={treatments}
                        value={formState.treatments}
                        getOptionLabel={(o) => o?.treatment_name || ""}
                        onChange={(e, val) =>
                            setFormState((prev) => ({ ...prev, treatments: val }))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Treatments *"
                                size="small"
                                sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        flexWrap: "nowrap",   // ✅ stop height expansion
                                        overflow: "hidden"
                                    }
                                }}
                            />
                        )}
                        sx={{
                            width: "25vw",
                            "& .MuiAutocomplete-tag": {
                                maxWidth: "70px"         // optional – prevents long chip stretch
                            }
                        }}
                    />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                    <FormControlLabel
                        control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} disabled={!EditID} size="small" />}
                        label="Active"
                    />
                    <Box>
                        <Button size="small" variant="outlined" sx={{ textTransform: "capitalize", mr: 1 }} disabled={!commonDisable} onClick={clearForm}>
                            Clear
                        </Button>
                        <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }} disabled={!commonDisable} onClick={AddMapping}>
                            {EditID ? "Update" : "Save"}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* Table Section */}
            <Box sx={{ height: "64vh", width: "93vw", mt: ".5vw", backgroundColor: "white" }}>
                {tableView()}
            </Box>

            {/* Toast + Loader + Delete */}
            {message.isErrorMsg ? <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} /> : null}
            {message.successMsg ? <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} /> : null}
            {isDelete ? (
                <DeletePopup
                    DeletTitle={`This action will delete the mapping. Are you sure?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={() => {
                        setisDelete(false);
                        setdeletedID(null);
                    }}
                    removeData={deleteMapping}
                    ButtonText={"Yes"}
                />
            ) : null}
            <Loader loaderOpen={isloader} />
        </Box>
    );
};

export default TherapyMappingMaster;
